module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "kbx-progress-label",
    staticStyle: {
      "left": "50%"
    },
    style: (_vm.getDivStyle())
  }, [_c('span', {
    staticClass: "kbx-progress-svg",
    domProps: {
      "innerHTML": _vm._s(_vm.getSVG())
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "kbx-label-content",
    style: (_vm.getSpanStyle()),
    attrs: {
      "klickbox-edit-item": "progress-bar-active",
      "klickbox-edit-item-dad": "progress",
      "klickbox-edit-label": _vm.$t('edit.canvas.active_item')
    }
  }, [_vm._v("50%")])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-3acebf39!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/progressbar/percent/Active.vue
 ** module id = 803
 ** module chunks = 1
 **/